<template>
  <router-link :to="{ path: '/' }" class="d-block text-center">
    <b-img src="~@/assets/images/lv_logo_w.png" alt="LV" />
  </router-link>
</template>

<script>
export default {
  name: 'Logo'
};
</script>
